import { render, staticRenderFns } from "./UserPhaseEditor.vue?vue&type=template&id=7fb04859&"
import script from "./UserPhaseEditor.vue?vue&type=script&lang=js&"
export * from "./UserPhaseEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports